import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { PActionButtonModule } from '@panaya/ui/p-action-button';
import { PCheckboxModule } from '@panaya/ui/p-checkbox';
import { PExpandAreaTriggerModule } from '@panaya/ui/p-expand-area-trigger';
import { PFieldModule as PublishablePFieldModule } from '@panaya/ui/p-field';
import { PFieldOutlineTextModule } from '@panaya/ui/p-field-outline-text';
import { PFieldTextModule } from '@panaya/ui/p-field-text';
import { PIconModule } from '@panaya/ui/p-icon';
import { PLinkModule } from '@panaya/ui/p-link';
import { PTooltipModule } from '@panaya/ui/p-tooltip';
import { PipeModule } from '@panaya/ui/pipes';
import { MentionModule } from 'angular-mentions';
import { PButtonModule } from '@panaya/ui/p-button';
import { PChipGroupModule } from '../p-hashtag/p-chip-group';
import { PMultipleProgressBarModule } from '../p-multiple-progress-bar/p-multiple-progress-bar.module';
import { PSlideToggleModule } from '../p-slide-toggle';
import { PStaticProgressBarModule } from '../p-static-progress-bar';
import { PStatusMainLabelModule } from '../p-status-main-label';
import { PStatusSubLabelModule } from '../p-status-sub-label';
import { LabelAlignerDirective } from './label-aligner.directive';
import { PFieldAutoCompleteComponent } from './p-field-auto-complete/p-field-auto-complete.component';
import { PFieldCheckboxComponent } from './p-field-checkbox/p-field-checkbox.component';
import { PFieldDateRangeComponent } from './p-field-date-range/p-field-date-range.component';
import { PFieldDateComponent } from './p-field-date/p-field-date.component';
import { PFieldEditComponent } from './p-field-edit/p-field-edit.component';
import { PFieldEntityStatusComponent } from './p-field-entity-status/p-field-entity-status.component';
import { PFieldFileComponent } from './p-field-file/p-field-file.component';
import { PFieldHeadingComponent } from './p-field-heading/p-field-heading.component';
import { PFieldHrefComponent } from './p-field-href/p-field-href.component';
import { PFieldHtmlComponent } from './p-field-html/p-field-html.component';
import { PFieldLabelComponent } from './p-field-label/p-field-label.component';
import { PFieldLinkComponent } from './p-field-link/p-field-link.component';
import { PFieldMultiCheckboxComponent } from './p-field-multi-checkbox/p-field-multi-checkbox.component';
import { PFieldMultipleProgressBarComponent } from './p-field-multiple-progress-bar/p-field-multiple-progress-bar.component';
import { PFieldNumericComponent } from './p-field-numeric/p-field-numeric.component';
import { PFieldRadioComponent } from './p-field-radio/p-field-radio.component';
import { PFieldRichTextComponent } from './p-field-rich-text/p-field-rich-text.component';
import { PFieldSingleSelectComponent } from './p-field-single-select/p-field-single-select.component';
import { PFieldSlideToggleWorkaroundComponent } from './p-field-slide-toggle-workaround/p-field-slide-toggle-workaround.component';
import { PFieldSlideToggleComponent } from './p-field-slide-toggle/p-field-slide-toggle.component';
import { PFieldStaticProgressBarComponent } from './p-field-static-progress-bar/p-field-static-progress-bar.component';
import { PFieldStatusSubLabelComponent } from './p-field-status-sub-label/p-field-status-sub-label.component';
import { PFieldTimeComponent } from './p-field-time/p-field-time.component';
import { PFieldToggleComponent } from './p-field-toggle/p-field-toggle.component';
import { PFieldUserComponent } from './p-field-user-single-select/p-field-user.component';
import { PFieldUserAndGroupComponent } from './p-field-user-and-group/p-field-user-and-group.component';
import { PFieldWeekdayComponent } from './p-field-week-days/p-field-weekday.component';
import { PPickerMultiSelectComponent } from './p-picker-multi-select/p-picker-multi-select.component';
import { PPickerSingleSelectComponent } from './p-picker-single-select/p-picker-single-select.component';
import { PPartialListModule } from '../p-partial-list/p-partial-list.module';
import { PFieldPartialListComponent } from './p-field-partial-list/p-field-partial-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MarkdownModule } from 'ngx-markdown';
import { PFieldCommentWithActionComponent } from './p-field-comment-with-action/p-field-comment-with-action.component';

@NgModule({
    declarations: [
        PFieldLabelComponent,
        PFieldToggleComponent,
        PFieldDateComponent,
        PFieldNumericComponent,
        PFieldRadioComponent,
        PPickerMultiSelectComponent,
        PFieldCheckboxComponent,
        LabelAlignerDirective,
        PFieldMultiCheckboxComponent,
        PFieldFileComponent,
        PFieldRichTextComponent,
        PFieldDateRangeComponent,
        PFieldSlideToggleComponent,
        PFieldSlideToggleWorkaroundComponent,
        PFieldHeadingComponent,
        PFieldUserComponent,
        PFieldUserAndGroupComponent,
        PFieldHtmlComponent,
        PFieldHrefComponent,
        PFieldStaticProgressBarComponent,
        PFieldAutoCompleteComponent,
        PFieldLinkComponent,
        PPickerSingleSelectComponent,
        PFieldSingleSelectComponent,
        PFieldEntityStatusComponent,
        PFieldMultipleProgressBarComponent,
        PFieldStatusSubLabelComponent,
        PFieldTimeComponent,
        PFieldWeekdayComponent,
        PFieldEditComponent,
        PFieldPartialListComponent,
        PFieldCommentWithActionComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        PublishablePFieldModule,
        PFieldOutlineTextModule,
        PFieldTextModule,
        PExpandAreaTriggerModule,
        MatFormFieldModule,
        PStatusMainLabelModule,
        PChipGroupModule,
        PStaticProgressBarModule,
        PMultipleProgressBarModule,
        PSlideToggleModule,
        PStatusSubLabelModule,
        MatInputModule,
        MatTooltipModule,
        PTooltipModule,
        MatAutocompleteModule,
        PCheckboxModule,
        PButtonModule,
        MatDatepickerModule,
        PIconModule,
        TranslateModule,
        PLinkModule,
        MatCheckboxModule,
        ExtendedModule,
        MatRadioModule,
        MentionModule,
        MatMenuModule,
        PipeModule,
        MatListModule,
        ScrollingModule,
        MatNativeDateModule,
        PActionButtonModule,
        PPartialListModule,
        MarkdownModule.forChild()
    ],
    exports: [
        PublishablePFieldModule,
        PFieldOutlineTextModule,
        PFieldLabelComponent,
        PFieldToggleComponent,
        PFieldDateComponent,
        PFieldSingleSelectComponent,
        PPickerMultiSelectComponent,
        PFieldNumericComponent,
        PFieldRadioComponent,
        PFieldCheckboxComponent,
        LabelAlignerDirective,
        PFieldMultiCheckboxComponent,
        PFieldMultipleProgressBarComponent,
        PFieldFileComponent,
        PPickerSingleSelectComponent,
        PFieldRichTextComponent,
        PFieldDateRangeComponent,
        PFieldSlideToggleComponent,
        PFieldHeadingComponent,
        PFieldUserComponent,
        PFieldUserAndGroupComponent,
        PFieldHtmlComponent,
        PFieldHrefComponent,
        PFieldStaticProgressBarComponent,
        PFieldAutoCompleteComponent,
        PFieldTextModule,
        PExpandAreaTriggerModule,
        PFieldLinkComponent,
        PFieldEntityStatusComponent,
        PFieldStatusSubLabelComponent,
        PFieldTimeComponent,
        PFieldWeekdayComponent,
        PFieldEditComponent,
        PFieldSlideToggleWorkaroundComponent,
        PFieldPartialListComponent,
        PFieldCommentWithActionComponent
    ]
})
export class PFieldModule {}
